export default "__VITE_ASSET__B520xPSP__"